export default __webpack_public_path__ + "img/video.2e355ba3.png";